import { render, staticRenderFns } from "./ClubPriceInfo.vue?vue&type=template&id=ddb59092&scoped=true&"
import script from "./ClubPriceInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubPriceInfo.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClubPriceInfo.vue?vue&type=style&index=0&id=ddb59092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb59092",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb59092')) {
      api.createRecord('ddb59092', component.options)
    } else {
      api.reload('ddb59092', component.options)
    }
    module.hot.accept("./ClubPriceInfo.vue?vue&type=template&id=ddb59092&scoped=true&", function () {
      api.rerender('ddb59092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ClubPriceInfo.vue/ClubPriceInfo.vue"
export default component.exports